import React from 'react';

const SliderItem = (props) => {
    return (
        <div className={'slider-item' + (props.active ? ' active' : '')} >{props.children}</div>
    )
}

export default SliderItem;